import { render, staticRenderFns } from "./buyGoldSendParking.vue?vue&type=template&id=0cc8af76&scoped=true"
import script from "./buyGoldSendParking.vue?vue&type=script&lang=js"
export * from "./buyGoldSendParking.vue?vue&type=script&lang=js"
import style0 from "./buyGoldSendParking.vue?vue&type=style&index=0&id=0cc8af76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc8af76",
  null
  
)

export default component.exports